import type { GraphNode } from '../graph/nodeDefs.js';
import { interactionState } from './viewportState.js';
import { isNodeDragHandleTarget } from './nodeDragHandles.js';

export function createNodeDragHandler(setSelectedNode: (nodeId: string | null) => void): (el: HTMLElement, node: GraphNode) => void {
  return function setupNodeDrag(el: HTMLElement, node: GraphNode): void {
    el.addEventListener('mousedown', e => {
      if (e.button !== 0) {
        return;
      }
      if (!isNodeDragHandleTarget(e.target)) {
        return;
      }
      e.stopPropagation();
      setSelectedNode(node.id);
      const startX = e.clientX;
      const startY = e.clientY;
      const origX = node.x;
      const origY = node.y;
      interactionState.draggingNode = { node, startX, startY, origX, origY, moved: false };
    });
  };
}
